import * as defaultConst from '../../constants/default_constants'
import * as linkConst from '../../constants/link_constants'
import Validators from './validators'
import { BaseManipStateFn, BaseTableState } from './base'

import Moment from 'moment'
import { extendMoment } from 'moment-range'
const moment = extendMoment(Moment)

export default (store) => {
  class ManipState extends BaseManipStateFn(store) {
    requiredOptions = [
      'Countries',
      'Platforms',
      linkConst.LOAD_OPTIONS.vatrates
    ]

    onLoaded (entity) {
      store.options.get('Countries')
        .replace(store.options.get('Countries').slice()
          .filter(c => c.value.length === 2))
      super.onLoaded(entity)
    }

    prepareNew () {
      store.options.get('Countries')
        .replace(store.options.get('Countries').slice()
          .filter(c => c.value.length === 2))
    }

    onSaved (saved) {
      super.onSaved(saved)
      store.markDirty('vatrates')
    }

    createtitle = store.__(linkConst.LINK_VATRATES_TITLE).concat(defaultConst.TITLE_DIVIDER) + store.__(defaultConst.TITLE_CREATE)
    edittitle = store.__(linkConst.LINK_VATRATES_TITLE).concat(defaultConst.TITLE_DIVIDER) + store.__(defaultConst.TITLE_EDIT)
    timeRestriction = 'vatrates'
    validators = {
      region: [
        Validators.isMandatory(store),
        Validators.maxLength(store, 2)
      ],
      rate: [
        Validators.isMandatory(store),
        Validators.positiveFloat(store)
      ],
      platform: Validators.isMandatory(store),
      valid_from: [
        Validators.isMandatoryDate(store),
        Validators.isValidFromTo(store)
      ],
      valid_to: [
        Validators.isMandatoryDate(store),
        Validators.isValidFromTo(store)
      ],
      _global: (vals, errors) => {
        const items = store.options.has('vatrates') && store.options.get('vatrates')
        const errs = []

        const isOverlapping = (cStart, cEnd, nStart, nEnd) => {
          if ((!cStart || !cEnd) || (!nStart || !nEnd)) {
            // without test if values missing
            return false
          }
          const cRange = cStart && cEnd && moment.range(cStart, cEnd)
          const nRange = nStart && nEnd && moment.range(nStart, nEnd)
          return (
            cRange.overlaps(nRange) || nRange.overlaps(cRange) ||
            moment(cStart).format('YYYY-MM-DD') === moment(nEnd).format('YYYY-MM-DD') ||
            moment(nStart).format('YYYY-MM-DD') === moment(cEnd).format('YYYY-MM-DD')
          )
        }

        items.slice().filter(i =>
          isOverlapping(
            i.valid_from,
            i.valid_to,
            vals.get('valid_from') || null,
            vals.get('valid_to') || null
          ) &&
        (!vals.has('id') || i.id !== vals.get('id')) &&
        i.region === vals.get('region') &&
        i.platform === vals.get('platform')
        ).length > 0 &&
        errs.push(store.__('VAT rates can not overlap in the same region.'))

        return errs.length > 0
          ? errs
          : undefined
      }
    }
  }

  class TableState extends BaseTableState {
    attrs = [
      'id', 'region', 'rate', 'platform', 'valid_from', 'valid_to'
    ]

    headertitles = [
      store.__('ID'), store.__('region'), store.__('rate'), store.__('platform'),
      store.__('valid from'), store.__('valid to')
    ]

    timeRestriction = 'vatrates'
    title = store.__(linkConst.LINK_VATRATES_TITLE)
    defaultSort = linkConst.DEFAULT_SORT[linkConst.LINK_VATRATES]

    init () {
      store.loadEnumOptions('Countries')
      store.loadEnumOptions('Platforms')
      return super.init()
    }
  }

  return { ManipState, TableState }
}
